import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">‘WE NEED TO IMPROVE THIS PROCESS’</span>
                                            </div>
                                            <p>How often do you hear that, or say it yourself?
                                                Unfortunately, when a system fails, the root cause can be
                                                difficult to identify in the crescendo of users’
                                                frustration! However, we will guide you through the problem,
                                                from identification to resolution. We will help you identify
                                                problems and win support for change from your colleagues. At
                                                the same time, we will remind you of the need for continuous
                                                improvement and, most importantly, continual review. This is
                                                no solo task – it has to involve others from the beginning
                                                because, ultimately, a process is only as good as its
                                                users!</p>
                                            <p>There are four key stages in the process of continual
                                                review:</p>
                                            <div className="leftimg"><img
                                                src={require('@images/why-do-we-need-to-improve-processes.png')}/>
                                            </div>
                                            <div className="paraspace"><p>When identifying needs for change,
                                                establish whether it’s about a process itself or some other
                                                factor such as staff training or a change in business
                                                direction. Here are some pointers:</p></div>
                                            <ul className="greenbullet-list uiheading thought-list-pad">
                                                <li><p>What is wrong?</p></li>
                                                <li><p>How far through the process is it?</p></li>
                                                <li><p>Is it the whole process?</p></li>
                                                <li><p>Is there a training need?</p></li>
                                                <li><p>Is the problem with the process caused by someone
                                                    else further along the line?</p></li>
                                                <li><p>What is the impact of the problem?</p></li>
                                                <li><p>Who is responsible for this process?</p></li>
                                                <li><p>How widespread is the issue?</p></li>
                                            </ul>
                                            <p>It’s important to review the answers to the above questions
                                                before moving on to the consultation phase (which you might
                                                discover you don’t need if it’s a specific problem that can
                                                be easily put right).</p>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}